export default __webpack_public_path__ + "static/media/calconvert_s3.6f6a2428.png";